import { Reveal, Overline } from "@/components/Shared";
import { Building2, Handshake, GraduationCap, Satellite, BarChart3, Coins, Users, Atom } from "lucide-react";

const RECORDS = [
  {
    id: "meity",
    icon: Building2,
    tag: "Government of India",
    title: "Ministry of Electronics & IT (MeitY)",
    desc: "Leadership tenure as Technical Officer inside India's digital ministry, direct fluency in national deep-tech missions, policy drafting and public-sector program delivery.",
  },
  {
    id: "ihub",
    icon: Handshake,
    tag: "Ecosystem MoU · Sep 2025",
    title: "i-Hub Gujarat, Government of Gujarat",
    desc: "Signed strategic MoU with the Gujarat Student Startup & Innovation Hub: startup mentorship, investor connections and capacity-building across the state ecosystem.",
  },
  {
    id: "nielit",
    icon: GraduationCap,
    tag: "Ecosystem Alliance",
    title: "NIELIT, Digital Skilling",
    desc: "Collaboration with the National Institute of Electronics & Information Technology on global digital skilling initiatives for India's technology workforce.",
  },
  {
    id: "stpinext",
    icon: Satellite,
    tag: "Ecosystem Alliance",
    title: "STPI-NEXT, MeitY Ecosystem",
    desc: "Engagement with AIC STPINEXT Initiatives (Software Technology Parks of India) to connect startups with venture capital and international expansion corridors.",
  },
  {
    id: "private-analytics",
    icon: BarChart3,
    tag: "Private Sector",
    title: "Varahe Analytics",
    desc: "Consulting across high-stakes analytics engagements, the private-sector counterpart to a career grounded in public institutions.",
  },
  {
    id: "gsc",
    icon: Coins,
    tag: "Ecosystem MoU · Singapore",
    title: "GSC Golden State Capital",
    desc: "Strategic MoU with the Singapore-headquartered family office and private equity firm, opening cross-border capital corridors for portfolio ventures across India, Singapore and the United States.",
  },
  {
    id: "inlighten",
    icon: Users,
    tag: "Ecosystem MoU · London",
    title: "Inlighten Leadership",
    desc: "Leadership development alliance with the London consultancy founded by Pooja Lorra Dhiman, pairing deep-tech mandates with executive coaching and organisational change expertise.",
  },
  {
    id: "iit-ropar",
    icon: Atom,
    tag: "Ecosystem MoU · Academia",
    title: "IIT Ropar",
    desc: "Institutional MoU with the Indian Institute of Technology Ropar, connecting research talent and deep-tech laboratories to incubation, IP advisory and market pathways.",
  },
];

export default function TrackRecord() {
  return (
    <section
      id="track-record"
      data-testid="track-record-section"
      className="border-y border-[rgba(212,175,55,0.15)] bg-[#0A1222]/60 py-24 md:py-32"
    >
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <Reveal>
            <Overline>Track Record, Govt × Private</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 data-testid="track-record-heading" className="mt-4 font-serif text-3xl tracking-tight text-[#F7F5F0] sm:text-4xl lg:text-5xl">
              Trusted inside the <em className="gold-text not-italic">corridors of power</em> and the market.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#94A3B8]">
              Few consultancies have sat on both sides of the table. BYOT's leadership has
              built programs within the Government of India and delivered for private-sector
              analytics clients, a duality that de-risks every engagement.
            </p>
          </Reveal>
        </div>

        <div className="flex flex-col gap-4">
          {RECORDS.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.06}>
              <article
                data-testid={`record-card-${r.id}`}
                className="group flex gap-5 border border-[rgba(212,175,55,0.15)] bg-[#0F1A2E]/70 p-6 transition-colors duration-500 hover:border-[#D4AF37]/50 hover:bg-[#16243E] sm:p-7"
              >
                <r.icon size={26} strokeWidth={1.4} className="mt-1 shrink-0 text-[#D4AF37]" />
                <div>
                  <p className="font-mono-alt text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]">{r.tag}</p>
                  <h3 className="mt-2 font-serif text-xl text-[#F7F5F0] sm:text-2xl">{r.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#94A3B8]">{r.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
